import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography } from '../../../styles/typography';

export const containerCss = css(typography.effra18, {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 56,
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: 2,
  'select::-ms-expand': {
    display: 'none',
  },
});

export const timeSelectContainerCss = css({
  textAlign: 'right',
});

export const selectContainerCss = css({
  position: 'relative',
  minWidth: 70,
});

export const selectCss = css(typography.effra18, {
  width: '100%',
  background: colorsPalette.transparent,
  border: 'none',
  color: colorsPalette.black,
  WebkitAppearance: 'none',
  '&select::ms-expand': {
    display: 'none',
  },
});
